import React from 'react';
import CepField from '@catalogo/ui-americanas-mobile-cep-field';
import withFreightV2 from '@catalogo/service-americanas-product/src/hocs/freight-v2';
import LasaOffer from '@catalogo/ui-americanas-mobile-lasa-offer/src';
import FreightOptions from '@catalogo/ui-americanas-mobile-freight/src/components/freight-options';
import { Loading } from '@catalogo/ui-americanas-mobile-freight/src/components/loading';
import FreightMoreOptions from '@catalogo/ui-americanas-mobile-freight/src/components/freight-more-options';
import { PickupMessage } from '@catalogo/ui-americanas-mobile-freight/src/components/pickup-message';
import InternationalLink from '@catalogo/ui-americanas-mobile-freight/src/components/international-link';
import {
  WarningContainer,
  ViewUI,
  CellUI,
  LaunchWrapper,
  LaunchText,
} from '@catalogo/ui-americanas-mobile-freight/src/styles';
import { Container, Wrapper } from './styles';

export const Freight = props => {
  const {
    freight,
    freightError,
    toogleClick,
    shouldCall,
    warningMessage,
    product,
    lasaOfferData,
    international,
    showContentFreight,
    isLoading,
    showLoader,
  } = props;

  if (showLoader) {
    return <Loading />;
  }

  if (!freightError) {
    return (
      <Container>
        <CepField onClick={toogleClick} label="calcular frete e prazo" error={freightError} address={shouldCall} />
        {showContentFreight && (
          <Wrapper>
            <FreightOptions freight={freight} isLoading={isLoading} />
            <PickupMessage options={freight?.options || []} />
            <CellUI flex={1}>
              <ViewUI>
                {product?.isPreSale && (
                  <LaunchWrapper>
                    <LaunchText>*prazo válido após o lançamento em {product?.launchingAt}</LaunchText>
                  </LaunchWrapper>
                )}
              </ViewUI>
            </CellUI>
            {!!warningMessage && <WarningContainer text={warningMessage} />}
            <LasaOffer lasaOfferData={lasaOfferData} />
            {freight?.hasMoreOptions && <FreightMoreOptions />}
          </Wrapper>
        )}
        {international && <InternationalLink />}
      </Container>
    );
  }

  return (
    <Container>
      <CepField onClick={toogleClick} label="calcular frete e prazo" error={freightError} address={shouldCall} />
    </Container>
  );
};

export default withFreightV2(Freight);
